import React from 'react';
import { Tax } from './tax';
export default React.memo(Tax);
